import { Collection } from 'modules/core/lib/mobx-rest'

import Template from 'modules/reports/store/models/Template'

class Templates extends Collection<Template> {
  get cacheKey(): string {
    return 'templates'
  }

  model() {
    return Template
  }

  bySlug(slug: string): Template | null | undefined {
    return this.find({
      slug,
    })
  }

  // Model not coming from database so need to define primary key
  get primaryKey(): string {
    return 'slug'
  }
}

const singleton: Templates = new Templates()

export default singleton
